/**
 * « Mon ordre » tel que le serveur le rend avec une feuille (`Feuille.ordreHierarchique`, ton
 * rang puis l'arrivée, calculé par le moteur : `ordreHierarchique`, `server/src/domain/
 * hierarchie.ts`). L'écran ne le recalcule pas (chantier nettoyage-feuille, ticket 04) : il range
 * ses bulles à la place que cet ordre leur donne.
 *
 * Une bulle que l'ordre ne connaît pas passe après, dans l'ordre reçu (le tri est stable).
 */
export function selonMonOrdre(ordre: readonly string[]): (a: { id: string }, b: { id: string }) => number {
  const place = new Map(ordre.map((id, i) => [id, i]));
  const de = (id: string) => place.get(id) ?? Infinity;
  return (a, b) => {
    const pa = de(a.id);
    const pb = de(b.id);
    return pa === pb ? 0 : pa < pb ? -1 : 1;
  };
}
